import React, { useEffect, useState } from "react";
import axios from '../../api/apiClient';
import { domain, token } from "../Security"; // ⬅ IMPORT HERE

export const PositionIdSelect = ({ 
  label,
  isRequired = false,
  isDisabled = false,
  positionId,
  setPositionId
}) => {
  const [data, setData] = useState([]);

  const fetchData = async () => {
    try {
      const apiUrl = `${domain}/api/Position/active`;
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      const sorted = [...response.data].sort((a, b) =>
        a.description.localeCompare(b.description)
      );
      setData(sorted);
    } catch (error) {
      console.error("Error fetching positions:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="mb-1">
      {label && (
        <label className="block text-sm font-medium text-gray-600 mb-1.5">
          {label} {isRequired && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <select
        value={positionId}
        onChange={(e) => setPositionId(e.target.value)}
        disabled={isDisabled}
        className="w-full box-border border border-solid border-gray-300 rounded-md px-3 py-2 text-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
      >
        <option value="">None</option>
        {data.map((pos) => (
          <option key={pos.id} value={pos.id}>
            {pos.description}
          </option>
        ))}
      </select>
    </div>
  );
};

export const DepartmentIdSelect = ({
  label,
  isRequired = false,
  isDisabled = false,
  departmentId,
  setDepartmentId,
  className = "",
  error = "",
}) => {
  const [data, setData] = useState([]);

  const fetchData = async () => {
    try {
      const apiUrl = `${domain}/api/Department/active`;
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const sorted = [...response.data].sort((a, b) =>
        a.description.localeCompare(b.description)
      );
      setData(sorted);
    } catch (err) {
      console.error("Error fetching departments:", err);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className={`mb-1 ${className}`}>
      {label && (
        <label className="block text-sm font-medium text-gray-600 mb-1.5">
          {label}
          {isRequired && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}

      <select
        value={departmentId}
        onChange={(e) => setDepartmentId(e.target.value)}
        disabled={isDisabled}
        className={`w-full box-border border border-solid border-gray-300 rounded-md px-3 py-2 text-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${error ? "border-red-500" : ""
          }`}
      >
        <option value="">None</option>
        {data.map((dept) => (
          <option key={dept.id} value={dept.id}>
            {dept.description}
          </option>
        ))}
      </select>

      {error && <span className="text-red-500 text-sm mt-1 block">{error}</span>}
    </div>
  );
};